// @flow
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive/src';
import { AwardActions } from 'modules/awards/action';
import { AwardSelector } from 'modules/awards/selector';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { ProductBrowserSelector } from 'modules/productBrowser/selector';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { ProjectActions } from 'modules/project/actions';
import { ProjectSelector } from 'modules/project/selector';
import { TestimonialActions } from 'modules/testimonials/action';
import { TestimonialSelector } from 'modules/testimonials/selector';
import HomesBanner from 'components/organisms/homesBanner';
import { PageLoader } from 'components/molecules/pageLoader';
import Award from 'components/templates/awards';
import { ContactUsSection } from 'components/templates/contactUsSection';
import EDesignSection from 'components/templates/eDesign';
import FooterSection from 'components/templates/footer';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import MachineCraftSection from 'components/templates/machineCraft';
import OurHomesDifferences from 'components/templates/ourHomesDifference';
import PageTemplate from 'components/templates/pageTemplate';
import ProductBrowser from 'components/templates/productBrowser';
import { ProjectAnnouncementsSection } from 'components/templates/projectAnnouncementsSection';
import CompletedProjectsSection from 'components/templates/completedProjectsSection';
import ProjectBrowser from 'components/templates/projectBrowser';
import Testimonial from 'components/templates/testimonial';
import type { AppState } from 'modules/rootReducer';
import { NavigationUtil } from 'utils/NavigationUtil';
import { isEmpty, filter } from 'lodash';
import { RouteNames } from 'router';
import { LocationActions } from 'modules/location/actions';
import { LocationSelector } from 'modules/location/selector';
import { ProjectBrowserSelector } from 'modules/projectBrowser/selector';
import AllProperties from 'components/templates/allProperties';
import { ShareModal } from 'components/templates/shareModal';
import RenderSEO from 'components/atoms/renderSEO';
import { HeaderButtons } from 'components/atoms/headerButtons';

const OurHomes = props => {
  const {
    isLoading,
    isCmsPageLoading,
    getAnnouncements,
    announcements,
    getVerticals,
    verticals,
    verticalId,
    getSiteSettings,
    siteSettings,
    getProductBrowser,
    productBrowser,
    getPageData,
    machineCraftSection,
    ourDifferenceData,
    getBannerData,
    getContactDetails,
    contact,
    ourHomesBanner,
    getProjects,
    projectList,
    awardData,
    getAwardData,
    footerLink,
    getFooterLinkData,
    testimonialData,
    getTestimonialData,
    eDesign,
    cmsDetailsData,
    getCmsDetailsData,
    // getUserLocation,
    // userLocation,
    allProjectsRecommendedList,
    getCompletedProjects,
    completedProjects,
  } = props;

  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const type = 'Vertical';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [mapView, setMapView] = useState(false);

  useEffect(() => {
    getAnnouncements(verticalId);
    getVerticals();
    getSiteSettings();
    getProductBrowser();
    getContactDetails();
    getPageData();
    getBannerData();
    getProjects(verticalId);
    getAwardData(verticalId);
    getTestimonialData(verticalId, type);
    getCmsDetailsData();
    // getUserLocation();
    getCompletedProjects(verticalId);
    getFooterLinkData();
  }, []);
  if (isLoading || isCmsPageLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !announcements ||
    !projectList ||
    !ourDifferenceData ||
    !machineCraftSection ||
    !eDesign ||
    !testimonialData ||
    !awardData ||
    !productBrowser ||
    !getCmsDetailsData ||
    !cmsDetailsData ||
    !ourHomesBanner ||
    !allProjectsRecommendedList ||
    !footerLink
  ) {
    return null;
  }
  const selectedVertical = filter(verticals, ({ id }) => id === verticalId);
  const metaTagSEO =
    selectedVertical.length > 0 ? selectedVertical[0].metaTagSEO : '';
  // Get latest announcement
  const [announcement] = filter(announcements, { sortOrder: 1 });
  const {
    machineCraft: machineCraftOverlay,
    customiseWithEDesign,
  } = cmsDetailsData;

  // Share
  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const updateMapView = (theme, view) => {
    setTheme(theme);
    setMapView(view);
  };
  const CampaignCode = contact.campaignCode ? contact.campaignCode : '';

  const componentList = [
    ...(!isEmpty(ourHomesBanner)
      ? [
          {
            component: HomesBanner,
            data: { ourHomesBanner, announcement },
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
            ],
            theme: isMobile ? 'dark-theme' : 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: OurHomesDifferences,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'our-differences',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Our Differences',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(allProjectsRecommendedList)
      ? [
          {
            component: AllProperties,
            sectionId: 'properties',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Our Projects',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: {
              data: allProjectsRecommendedList,
              projectList,
              type: 'homes',
              showFilter: true,
            },
          },
        ]
      : []),
    ...(!isEmpty(productBrowser)
      ? [
          {
            component: ProductBrowser,
            data: { productData: productBrowser },
            sectionId: 'products',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Product Browser',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    ...(!isEmpty(announcements)
      ? [
          {
            component: ProjectAnnouncementsSection,
            data: {
              announcements,
              onGetInTouchClick: isModalOpen,
              checkForCTAButton: true,
            },
            sectionId: 'announcements',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Announcements',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            sectionName: 'announcement-section',
          },
        ]
      : []),
    // ...(!isEmpty(projectList.list)
    //   ? [
    //       {
    //         component: ProjectBrowser,
    //         data: { data: projectList, userLocation, updateMapView, mapView, type: 'projects' },
    //         mapView: mapView,
    //         sectionId: 'projects',
    //         breadcrumbList: [
    //           {
    //             breadcrumbName: 'TotalEnvironment',
    //             breadcrumbLink: RouteNames.landing,
    //           },
    //           {
    //             breadcrumbName: 'Homes',
    //             breadcrumbLink: RouteNames.homes,
    //           },
    //           {
    //             breadcrumbName: 'Project Browser',
    //             breadcrumbLink: '#',
    //           },
    //         ],
    //         theme: isMobile ? 'dark-theme' : 'light-theme',
    //       },
    //     ]
    //   : []),
    ...(!isEmpty(testimonialData)
      ? [
          {
            component: Testimonial,
            sectionId: 'testimonials',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Testimonials',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: { testimonialData, type: 'testimonial' },
          },
        ]
      : []),
    ...(!isEmpty(completedProjects)
      ? [
          {
            component: CompletedProjectsSection,
            data: {
              completedProjects,
              sectionHeading: 'Completed Projects',
            },
            theme: 'light-theme',
            sectionId: 'completed-projects',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Completed Projects',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(awardData)
      ? [
          {
            component: Award,
            sectionId: 'awards',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Awards',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: awardData,
          },
        ]
      : []),
    ...(!isEmpty(machineCraftSection)
      ? [
          {
            component: MachineCraftSection,
            data: {
              machineCraftSection,
              machineCraftOverlay,
            },
            sectionId: 'machine-craft',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'Machine-craft',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(eDesign)
      ? [
          {
            component: EDesignSection,
            data: {
              eDesign,
              customiseWithEDesign,
              togglePadding: !!machineCraftSection,
            },
            sectionId: 'eDesign',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: 'eDesign',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: {
        contact,
        verticals,
        verticalId,
        callPostLeadAPI: true,
        type: 'no-padding',
      },
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={'homes'} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        campaignCode={CampaignCode}
        salesEmail={contact.email}
        headerButtons={
          <HeaderButtons
            shareTheme={'dark'}
            getInTouchTheme={'light'}
            setIsModalOpen={setIsModalOpen}
            setIsShareModalOpen={setIsShareModalOpen}
          />
        }
      />
      <GetInTouchModal
        isOpen={isModalOpen}
        onClosePress={closeModal}
        campaignCode={CampaignCode}
        salesEmail={contact.email}
        callPostLeadAPI={true}
        verticalId={verticalId}
      />
      <ShareModal
        isOpen={isShareModalOpen}
        onClosePress={closeShareModal}
        callPostLeadAPI={true}
      />
    </>
  );
};

const mapStateToProps = (state: AppState, props: any) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);
  return {
    isLoading:
      AwardSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      HomeSelector.isLoading(state) ||
      TestimonialSelector.getTestimonialLoading(state) ||
      ProjectSelector.getProjectLoading(state) ||
      ProjectSelector.getAnnouncementsLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state) ||
      ProductBrowserSelector.getProductBrowserLoading(state) ||
      ProjectSelector.getCompletedProjectsLoading(state),
      // LocationSelector.getUserLocationLoading(state),
    announcements: ProjectSelector.getAnnouncements(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    verticals: HomeSelector.getVerticals(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    footerLink: FooterSelector.getFooterData(state),
    productBrowser: ProductBrowserSelector.getProductBrowserData(state),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'our-difference',
      'The Total Environment Difference'
    ),
    ourHomesBanner: HomeSelector.getBanners(state, true, 'homes', ''),
    projectList: ProjectSelector.getProjects(state),
    awardData: AwardSelector.getAwardData(state),
    testimonialData: TestimonialSelector.getTestimonialData(state),
    eDesign: CmsPagesSelector.getCmsPages(
      state,
      'Customise With eDesign',
      false
    ),
    machineCraftSection: CmsPagesSelector.getCmsPages(
      state,
      'Machine-craft',
      false
    ),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
    // userLocation: LocationSelector.getUserLocation(state),
    allProjectsRecommendedList: ProjectBrowserSelector.getAllPropertiesRecommended(
      state
    ),
    contact: HomeSelector.getContactForVertical(state, verticalKey),
    completedProjects: ProjectSelector.getCompletedProjects(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getBannerData } = HomeActions;
  const {
    getAnnouncements,
    getProjects,
    getCompletedProjects,
  } = ProjectActions;
  const { getVerticals, getSiteSettings, getContactDetails } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getAwardData } = AwardActions;
  const { getTestimonialData } = TestimonialActions;
  const { getProductBrowser } = ProductBrowserAction;
  const { getCmsDetailsData } = CmsDetailsActions;
  // const { getUserLocation } = LocationActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getProjects,
      getAnnouncements,
      getVerticals,
      getSiteSettings,
      getBannerData,
      getPageData,
      getAwardData,
      getContactDetails,
      getTestimonialData,
      getProductBrowser,
      getCmsDetailsData,
      // getUserLocation,
      getCompletedProjects,
      getFooterLinkData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(OurHomes);
